<template>
  <footer class="footer">
    <div class="container-fluid">
      <nav class="pull-left">
        <ul>
        </ul>
      </nav>
      <div class="copyright pull-right">
      </div>
    </div>
  </footer>
</template>
<script>
  export default {}
</script>
<style>

</style>
